import { userContactInfoSchema } from '../../models/users/morph.js';
import { userContactInfo } from '../../models/users/zod.js';
import { clientGet } from '../../utils/fetchwrapper.js';
import { processBody } from '../../utils/fetchwrapperUtils/responseProcessors.js';

const getContactInfo = (origin, adURN, timeout) => clientGet({
    url: `${origin}/v1/contacts/ads/${adURN}`,
    timeoutMs: timeout,
}).then(processBody(userContactInfoSchema, userContactInfo));

export { getContactInfo };
//# sourceMappingURL=client.js.map
